import { Component, ViewEncapsulation, ChangeDetectionStrategy, 
  EventEmitter, Output, Input, Inject } from '@angular/core';

import { BillingResponse } from '@billing/entities/billing.payload';
import { IS_MOBILE } from '@app/modules/core/tokens/app.tokens';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-billing-options-saved',
  templateUrl: './billing-options-saved.component.html',
  styleUrls: ['./billing-options-saved.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BillingOptionsSavedComponent {

  @Input() options: BillingResponse[] = [];
  @Input() isInvalidContactInfo: boolean;
  
  @Output() toggleList: EventEmitter<void> = new EventEmitter();
  
  @Output() edit: EventEmitter<BillingResponse> = new EventEmitter();
  @Output() remove: EventEmitter<string> = new EventEmitter();
  @Output() selectBilling: EventEmitter<BillingResponse> = new EventEmitter();

  public readonly icons = Icon;

  constructor(@Inject(IS_MOBILE) public isMobile: boolean) { }

  public selectOption(billing: BillingResponse): void {
    this.selectBilling.emit(billing);
  }

}
